module.exports = __webpack_public_path__ + "static/media/triangle.ec138331.svg";